import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Churchgasm',
  date: new Date(2023, 3, 30),
  img: '/img/nun.jpeg',
  tracks: [
    {
      title: 'Two Guitars, Two Bass, One Cup',
      src: '/songs/2023-04-30/two_guitars.mp3',
    },
    {
      title: 'Cruisin\'',
      src: '/songs/2023-04-30/cruisin.mp3',
    },
    {
      title: 'Workin\' for the Man',
      src: '/songs/2023-04-30/workin_for_the_man.mp3',
    },
    {
      title: 'Keep it Goin\'',
      src: '/songs/2023-04-30/keep_it_goin.mp3',
    },
    {
      title: 'House of the Harmonic Minor',
      src: '/songs/2023-04-30/harmonic_minor.mp3',
    },
    {
      title: 'There\'s a Sandstorm Rising',
      src: '/songs/2023-04-30/sandstorm_rising.mp3',
    },
    {
      title: 'You know what you know (And you don\'t know what you don\'t know',
      src: '/songs/2023-04-30/what_you_know.mp3',
    },
    {
      title: 'You are my Baby',
      src: '/songs/2023-04-30/you_are_my_baby.mp3',
    },
    {
      title: 'I like it like that',
      src: '/songs/2023-04-30/i_like_it_like_that.mp3',
    },
    {
      title: 'Silhouette',
      src: '/songs/2023-04-30/silhouette.mp3',
    },
    {
      title: 'You want it (You got it)',
      src: '/songs/2023-04-30/you_want_it.mp3'
    },
    {
      title: 'Never Ending Tune',
      src: '/songs/2023-04-30/never_ending_tune.mp3',
    },
    {
      title: 'Doody doo doo (Getting Scooby-doopid with it)',
      src: '/songs/2023-04-30/doody_doo_doo.mp3',
    },
    {
      title: 'Acid Test Number 17 - The Subjects are behaving as expected',
      src: '/songs/2023-04-30/acid_test.mp3',
    },
  ]
}
export default album;